import { defineStore, acceptHMRUpdate } from 'pinia';
import i18n from '@/lang';
import { Locale } from 'vant';
import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import { getAssistantSetting } from '@/api';

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      token: null,
      refreshToken: null,
      userId: null,
      touristFingerprints: null, // 游客指纹
      agentSetting: {}, // 用户智能体设置
      lang: 'cn', // 语言设置
      // 路由参数
      exhibitionId: null,
      account: null, // 账号 用于登录
      user_id: null, // 小程序中  无法提供账号的时候  需要提供这个标记
      userInfo: {},
    }
  },
  getters: {
    // 用户标识 用于Agent记忆
    user() {
      return `${this.exhibitionId}_${this.userId || this.touristFingerprints}`
    },

    // 是否登录
    isLogin() {
      return !!this.userId
    },

  },
  actions: {
    /**
     * 初始化
     * @author: BYM<yongming.bai@outlook.com>
     * @param {Object} data 用户数据|浏览器指纹
     * @param {boolean} isItAVisitor 是否是游客
     */
    init(data, isItAVisitor) {
      this.clear()
      if (isItAVisitor) {
        this.touristFingerprints = data;
      } else {
        const { access_token, refresh_token, user_id } = data || {}
        this.userInfo = data || {};
        this.token = access_token;
        this.refreshToken = refresh_token;
        this.userId = user_id;
      }
    },
    /**
     * 初始化路由参数
     * @author: BYM<yongming.bai@outlook.com>
     */
    initQuery(data) {
      this.exhibitionId = data.exhibitionId
      this.account = data.account || null
      this.user_id = data.user_id || null
      // URL参数优先，其次保留已持久化的值，最后兜底 'cn'
      this.lang = data.lang || this.lang || 'cn'
    },
    /**
     * 设置语言
     * @author: BYM<yongming.bai@outlook.com>
     */
    setLang(lang = 'cn') {
      const langs = ['cn', 'en'];
      if (!langs.includes(lang)) return
      this.lang = lang
      i18n.global.locale.value = lang
      Locale.use(lang === 'cn' ? 'zh-CN' : 'en-US', lang === 'cn' ? zhCN : enUS)
    },
    /**
     * 清空用户数据
     * @author: BYM<yongming.bai@outlook.com>
     */
    clear() {
      this.token = null;
      this.refreshToken = null;
      this.userId = null;
      this.touristFingerprints = null;
      this.agentSetting = {};
    },

    /**
     * 获取小助手设定
     * @author: BYM<yongming.bai@outlook.com>
     */
    async assistantSetting() {
      if (!this.token) return;
      await getAssistantSetting({exhibitionId: this.exhibitionId}).then(({data: result, code}) => {
        if (code === 1000) {
          this.agentSetting = result
        }
      })
    }
  },
  // 本地缓存
  persist: {
    enabled: true,
    key: "user",
    storage: localStorage,
    paths: null,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}